export const alphabeticalSort = <T>(array: T[], field: string): T[] =>
    array.sort((a, b) => a[field].localeCompare(b[field]));
